import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Button,
	TextareaAutosize,
	Tooltip,
	Typography,
} from "@mui/material"
import axios from "axios"
import { useState } from "react"
import { SERVER_URI } from "../../utils/config"
import { SingleQuestion } from "./SingleQuestion"

export const SingleService = ({ service, order, phaseId, packageExtraInfo }) => {
	const total =
		service.costperunit +
		order.orderlines
			.filter((orderline) => orderline.serviceid === service.serviceid && orderline.phaseid === parseInt(phaseId))
			.reduce((acc, orderline) => acc + orderline.costperunit, 0)
	return (
		<Box>
			<Accordion>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
					<Tooltip
						title={
							<Box>
								<Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%" }}>
									<Typography variant="h5">Service:</Typography>
									<Typography variant="h5">{service.costperunit} €</Typography>
								</Box>
								<Typography variant="h5">
									Questions:{" "}
									{order.orderlines
										.filter(
											(orderline) =>
												orderline.serviceid === service.serviceid && orderline.phaseid === parseInt(phaseId)
										)
										.reduce((acc, orderline) => acc + orderline.costperunit, 0)}{" "}
									€
								</Typography>
								<Box
									sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%", mt: 1 }}>
									<Typography variant="h4">Total:</Typography>
									<Typography variant="h4">{total} €</Typography>
								</Box>
							</Box>
						}
						followCursor>
						<Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%" }}>
							<Typography variant="h4">{service.title}</Typography>
							{/* <Typography variant="h4">{total} €</Typography> */}
						</Box>
					</Tooltip>
				</AccordionSummary>
				<AccordionDetails>
					{service.servicequestions.map((question) => (
						<SingleQuestion
							key={`${phaseId}-${question.servicequestionid}`}
							question={question}
							order={order}
							phaseId={phaseId}
						/>
					))}
					{/* <Button variant='contained' color='primary' sx={{mt: 1 }} fullWidth>Kommentit</Button> */}
					<InfoSection order={order} service={service} phaseId={phaseId} packageExtraInfo={packageExtraInfo} />
				</AccordionDetails>
			</Accordion>
		</Box>
	)
}

export const InfoSection = ({ order, service, phaseId, packageExtraInfo }) => {
	const extrainfo = packageExtraInfo.find(
		(extrainfo) => extrainfo.serviceid === parseInt(service.serviceid) && extrainfo.phaseid === parseInt(phaseId)
	)
	const [info, setInfo] = useState(extrainfo ? extrainfo.info : "")

	const handleInfoUpdate = async () => {
		try {
			if (extrainfo) {
				await axios.put(`${SERVER_URI}/update_extrainfo/${extrainfo.id}`, {
					info: info,
				})
			} else {
				await axios.post(`${SERVER_URI}/create_extrainfo`, {
					orderinfoid: order.orderinfoid,
					serviceid: service.serviceid,
					phaseid: phaseId,
					info: info,
				})
			}
		} catch (error) {
			console.error(error)
		}
	}

	return (
		<Box sx={{ mt: 2 }}>
			<Accordion sx={(theme) => ({ backgroundColor: theme.palette.contrast.main })}>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
					<Typography variant="h6">Lisätiedot</Typography>
				</AccordionSummary>
				<AccordionDetails>
					{/* <Typography variant="h5">Kommentti</Typography> */}
					<TextareaAutosize
						aria-label="empty textarea"
						placeholder="Lisätiedot"
						style={{ fontFamily: "system-ui", width: "100%", fontSize: "1.5rem", resize: "none" }}
						minRows={3}
						maxRows={10}
						value={info}
						onChange={(e) => setInfo(e.target.value)}
					/>
					<Button variant="contained" color="primary" sx={{ mt: 1 }} fullWidth onClick={handleInfoUpdate}>
						Tallenna lisätiedot
					</Button>
				</AccordionDetails>
			</Accordion>
		</Box>
	)
}
